import {
  SCOPE_CONTRACT_OPPORTUNITIES,
  SCOPE_GRANT_OPPORTUNITIES,
  SCOPE_CONTRACT_AWARDS,
  SCOPE_AGENCIES_OFFICES,
  SCOPE_VENDORS,
  SCOPE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
  SCOPE_STATE_LOCAL_FORECASTS,
  SCOPE_STATE_LOCAL_AWARDS,
} from '../../constants';
import { NL_LANES } from './constants';

export const EZ_SEARCH_NL_LANES = [
  {
    scope: SCOPE_CONTRACT_OPPORTUNITIES,
    lane: NL_LANES.FEDERAL_CONTRACT_OPPORTUNITIES,
    routeKey: 'contract-opportunities',
  },
  {
    scope: SCOPE_GRANT_OPPORTUNITIES,
    lane: NL_LANES.FEDERAL_GRANT_OPPORTUNITIES,
    routeKey: 'grant-opportunities',
  },
  {
    scope: SCOPE_CONTRACT_AWARDS,
    lane: NL_LANES.FEDERAL_CONTRACT_AWARDS,
    routeKey: 'contract-awards',
  },
  {
    scope: SCOPE_AGENCIES_OFFICES,
    lane: NL_LANES.FEDERAL_AGENCIES,
    routeKey: 'agencies-offices',
  },
  {
    scope: SCOPE_VENDORS,
    lane: NL_LANES.VENDORS,
    routeKey: 'vendors',
  },
  {
    scope: SCOPE_STATE_LOCAL_CONTRACT_OPPORTUNITIES,
    lane: NL_LANES.SLED_OPPORTUNITIES,
    routeKey: 'state-local-contract-opportunities',
  },
  {
    scope: SCOPE_STATE_LOCAL_FORECASTS,
    lane: NL_LANES.SLED_FORECASTS,
    routeKey: 'state-local-forecasts',
  },
  {
    scope: SCOPE_STATE_LOCAL_AWARDS,
    lane: NL_LANES.SLED_AWARDS,
    routeKey: 'state-local-awards',
  },
];

export const NL_LANE_TO_EZ_SCOPE = Object.freeze(
  EZ_SEARCH_NL_LANES.reduce((acc, entry) => {
    acc[entry.lane] = entry.scope;
    return acc;
  }, {})
);

export const EZ_SCOPE_TO_NL_LANE = Object.freeze(
  EZ_SEARCH_NL_LANES.reduce((acc, entry) => {
    acc[entry.scope] = entry.lane;
    return acc;
  }, {})
);

export const EZ_SCOPE_TO_ROUTE_KEY = Object.freeze(
  EZ_SEARCH_NL_LANES.reduce((acc, entry) => {
    acc[entry.scope] = entry.routeKey;
    return acc;
  }, {})
);
